/**

 * 提示语侧边栏组件
 * 职责: 显示提示语类型菜单
 */
import React from 'react';
import { Layout, Menu } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import type { TemplateType } from '../../../types/ai-analysis-types';
import { PROMPT_TYPES } from '../constants/promptTypes';

const { Sider } = Layout;

interface PromptSidebarProps {
    selectedType: TemplateType;
    collapsed: boolean;
    onTypeChange: (type: TemplateType) => void;
    onCollapse: (collapsed: boolean) => void;
}

export const PromptSidebar: React.FC<PromptSidebarProps> = ({
    selectedType,
    collapsed,
    onTypeChange,
    onCollapse
}) => {
    return (
        <Sider
            width={200}
            theme="light"
            collapsible
            collapsed={collapsed}
            onCollapse={onCollapse}
            trigger={null}
            style={{ borderRight: '1px solid #f0f0f0', display: 'flex', flexDirection: 'column' }}
        >
            <div style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }} onClick={() => onCollapse(!collapsed)}>
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>
            <Menu
                mode="inline"
                selectedKeys={[selectedType]}
                style={{ flex: 1, borderRight: 0, paddingTop: 4 }}
                onClick={({ key }) => onTypeChange(key as TemplateType)}
                items={PROMPT_TYPES.map(item => ({
                    key: item.type,
                    icon: item.icon,
                    label: item.label,
                    title: item.description
                }))}
            />
        </Sider>
    );
};



